module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-progress-bar'), _vm._v(" "), _c('product-filter', {
    attrs: {
      "child-categories": _vm.childCategories,
      "tags": _vm.tags,
      "models": _vm.models,
      "filter-values": _vm.filterValues
    },
    on: {
      "input": _vm.handleFilter
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.handleLoadMore),
      expression: "handleLoadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "10"
    }
  }, [_c('product-list', {
    attrs: {
      "products": _vm.products
    }
  })], 1), _vm._v(" "), (false && _vm.pagesCount > 1) ? _c('div', [_c('nav', {
    staticClass: "pagination"
  }, [_c('a', {
    staticClass: "pagination-previous",
    attrs: {
      "disabled": !(_vm.page > 1)
    },
    on: {
      "click": function($event) {
        _vm.handlePageChange(_vm.page - 1)
      }
    }
  }, [_vm._v("Предыдущая\n      ")]), _vm._v(" "), _c('a', {
    staticClass: "pagination-next",
    attrs: {
      "disabled": !(_vm.page < _vm.pagesCount)
    },
    on: {
      "click": function($event) {
        _vm.handlePageChange(_vm.page + 1)
      }
    }
  }, [_vm._v("Следующая\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "pagination-list gl-pagination"
  }, _vm._l((_vm.pagesCount), function(n) {
    return _c('li', [_c('a', {
      class: [n === _vm.page ? 'is-current' : '', 'pagination-link'],
      on: {
        "click": function($event) {
          _vm.handlePageChange(n)
        }
      }
    }, [_vm._v(_vm._s(n) + "\n          ")])])
  }))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eb5f38f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./dev-packages/Shop/assets/site/widgets/category-product-list/Widget.vue
// module id = 630
// module chunks = 2